import React from "react";

const Give = () => {
  return (
    <div>
      <h1>Give Page</h1>
    </div>
  );
};

export default Give;
